import AdminCrudPage from '../../components/AdminCrudPage/AdminCrudPage';
import { getAdminSection } from '../../admin/adminSections';
import { getAdminCrudConfig } from '../../admin/adminCrudConfig';

export default function ReportsPage() {
  const section = getAdminSection('reports');
  const config = getAdminCrudConfig('reports');

  return (
    <AdminCrudPage
      label={section.label}
      singular={config.singular}
      description={config.description}
      note={config.note}
      stats={section.stats}
      fields={config.fields}
      initialItems={config.initialItems}
    />
  );
}
